import { formatRelativeToNow } from '@/lib/date';
import { richTextToPlainLabel } from '@/lib/rich-text';
import type { PatientAnamnesis } from '@/types/patient-anamnesis';

/** Approximate word count of a rich-text value, used for the status card. */
export const getAnamnesisWordCount = (html?: string | null): number => {
    const text = richTextToPlainLabel(html);
    if (!text) return 0;
    return text.split(/\s+/).filter(Boolean).length;
};

/** "342 palavras · editada há 2 dias" — the one-line summary of an anamnesis. */
export const describeAnamnesis = (anamnesis: PatientAnamnesis): string => {
    const wordCount = anamnesis.word_count ?? getAnamnesisWordCount(anamnesis.content_html);
    const words = `${wordCount} ${wordCount === 1 ? 'palavra' : 'palavras'}`;

    if (!anamnesis.updated_at) return words;

    const relative = formatRelativeToNow(anamnesis.updated_at);

    const verb = anamnesis.source === 'uploaded' ? 'enviada' : 'editada';
    return `${words} · ${verb} ${relative}`;
};
